import { DemandeAffiliationWarningTypeEnum } from '@graphql/generated';
import { DemandeWarning } from '@lib/models/demande-affiliation/types/demande-warning.type';

export class WarningMapper {
  public static fromGraphQl(
    input: DemandeAffiliationWarningTypeEnum
  ): DemandeWarning | undefined {
    const mapping: Record<DemandeAffiliationWarningTypeEnum, DemandeWarning> = {
      ACTIVITE_CONCURRENTE: 'activite_concurrente',
      EX_CONSULTANT: 'ex_consultant',
      INVESTISSEUR: 'investisseur',
    };
    return input ? mapping[input] : undefined;
  }
}
